import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-ed0e56b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onKeydown"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Koel's logo",
    src: _imports_0,
    width: "128"
  })
], -1))
const _hoisted_3 = { class: "current-version" }
const _hoisted_4 = {
  key: 0,
  "data-testid": "new-version-about"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "author" }, [
  /*#__PURE__*/_createTextVNode(" Made with ❤️ by "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://github.com/phanan",
    rel: "noopener",
    target: "_blank"
  }, "Phan An"),
  /*#__PURE__*/_createTextVNode(" and quite a few "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://github.com/koel/core/graphs/contributors",
    rel: "noopener",
    target: "_blank"
  }, "awesome"),
  /*#__PURE__*/_createTextVNode(" "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://github.com/koel/koel/graphs/contributors",
    rel: "noopener",
    target: "_blank"
  }, "contributors"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_7 = {
  key: 1,
  class: "credit-wrapper",
  "data-testid": "demo-credits"
}
const _hoisted_8 = { class: "credits" }
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Loving Koel? Please consider supporting its development via "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://github.com/users/phanan/sponsorship",
    rel: "noopener",
    target: "_blank"
  }, "GitHub Sponsors"),
  /*#__PURE__*/_createTextVNode(" and/or "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://opencollective.com/koel",
    rel: "noopener",
    target: "_blank"
  }, "OpenCollective"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))

import { orderBy } from 'lodash'
import { onMounted, ref } from 'vue'
import { isDemo } from '@/utils'
import { useNewVersionNotification } from '@/composables'
import { http } from '@/services'

import Btn from '@/components/ui/Btn.vue'

type DemoCredits = {
  name: string
  url: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutKoelModal',
  emits: ["close"],
  setup(__props, { emit }: { emit: ({ (e: 'close'): void }), expose: any, slots: any, attrs: any }) {

const credits = ref<DemoCredits[] | null>(null)

const {
  shouldNotifyNewVersion,
  currentVersion,
  latestVersion,
  latestVersionReleaseUrl
} = useNewVersionNotification()


const close = () => emit('close')

onMounted(async () => {
  credits.value = isDemo() ? orderBy(await http().get<DemoCredits[]>('demo/credits'), 'name') : null
})

return (_ctx: any,_cache: any) => {
  const _directive_koel_focus = _resolveDirective("koel-focus")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "about text-secondary",
    "data-testid": "about-koel",
    tabindex: "0",
    onKeydown: _withKeys(close, ["esc"])
  }, [
    _createElementVNode("main", null, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, "Koel " + _toDisplayString(_unref(currentVersion)), 1),
      (_unref(shouldNotifyNewVersion))
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
            _createElementVNode("a", {
              href: _unref(latestVersionReleaseUrl),
              target: "_blank"
            }, " A new version of Koel is available (" + _toDisplayString(_unref(latestVersion)) + ")! ", 9, _hoisted_5)
          ]))
        : _createCommentVNode("", true),
      _hoisted_6,
      (credits.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createTextVNode(" Music by "),
            _createElementVNode("ul", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(credits.value, (credit) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: credit.name
                }, [
                  _createElementVNode("a", {
                    href: credit.url,
                    target: "_blank"
                  }, _toDisplayString(credit.name), 9, _hoisted_9)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_10
    ]),
    _createElementVNode("footer", null, [
      _createVNode(Btn, {
        "data-testid": "close-modal-btn",
        red: "",
        rounded: "",
        onClick: _withModifiers(close, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createTextVNode("关闭")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 40, _hoisted_1)), [
    [_directive_koel_focus]
  ])
}
}

})